import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({
  custom: {
    fontSizes: { bodyG },
    palette: { colorSupportMidnight, colorVeryLightGray },
  },
  palette: {
    common: { white },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    submitLabel: {
      textTransform: 'uppercase',
    },
    dialogContent: {
      color: colorSupportMidnight,
      background: white,
      display: 'inline-block',
      fontSize: bodyG,
      fontWeight: 500,
      minHeight: 141,
      padding: 3 * unit,
      width: '100%',
    },
    dialogActions: {
      background: colorVeryLightGray,
    },
    contentLabel: {
      fontSize: bodyG,
      fontWeight: 500,
    },
  });
